import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import SettingsNav from "../../../../parts/settings-nav";
import { SettingsBackHandler } from "../../../coaching-portal/settings/components/SettingsBackHandler";
import { GymLocationDesktop } from "../../../../parts/cards/GymLocationDesktop";
import { GymLocationMobile } from "../../../../parts/cards/GymLocationMobile";

const GymLocations = ({ gymLocations, locals }) => {
  const { t } = useTranslation("dashboard");
  const [gymLocationsState, setGymLocationsState] = useState(gymLocations);
  // Team Coach can view org settings but not change them — the server
  // already rejects the POST, this just keeps these actions from
  // silently failing.
  const isReadOnly = locals?.organizationRoleName === "Team Coach";

  /**
   * Delete a location
   * @param {*} e
   */
  const deleteLocation = (e, index) => {
    if (
      process.browser &&
      confirm(t("gymLocations.deleteLocationConfirm"))
    ) {
      e.stopPropagation();
      e.preventDefault();
      const bodyformatting = gymLocationsState.filter(
        (element, i) => index !== i
      );
      setGymLocationsState(bodyformatting);
      submit(`/actions/user/press-custom-branding/gym-location`, {
        method: "POST",
        body: { bodyformatting },
      });
    }
  };

  /**
   * Edit a location
   * @param {*} e
   * @param {*} email
   * @param {*} contact
   */
  const redirectToEdit = (e, coordinates, contact) => {
    let body = {
      editingGym: "true",
      gymLong: coordinates.long,
      gymLat: coordinates.lat,
      gymContact: contact,
    };

    e.preventDefault();
    submit(`/actions/refresh`, {
      method: "GET",
      body,
    });
  };

  /**
   * Open the modal
   * @param {*} e
   * @param {*} email
   * @param {*} contact
   */
  const redirectToModal = (e, coordinates, contact) => {
    let body = {
      "modal[type]": "watch-gym-detail",
      gymLong: coordinates.long,
      gymLat: coordinates.lat,
      gymContact: contact,
    };

    e.preventDefault();
    submit(`/actions/refresh`, {
      method: "GET",
      body,
    });
  };

  return (
    <main className="settings">
      <SettingsNav classNames="mobile-hidden" />

      <section className="gym-locations">
        <h3 className="force-mobile-hidden">{t("gymLocations.title")}</h3>
        <div className="only-show-mobile">
          <SettingsBackHandler title={t("gymLocations.title")} />
          {!isReadOnly && (
            <a
              role="button"
              data-button-type="outline"
              href="/coaching-portal/settings/gym-locations?addNewGym=true"
            >
              <span>{t("gymLocations.addNewGym")}</span>
            </a>
          )}
        </div>
        {isReadOnly && (
          <p role="alert">{t("settingsNav.readOnlyTooltip")}</p>
        )}

        <GymLocationDesktop
          gymLocations={gymLocationsState}
          onDelete={deleteLocation}
          onEdit={redirectToEdit}
          onTimingModal={redirectToModal}
          readOnly={isReadOnly}
        />

        <GymLocationMobile
          gymLocations={gymLocationsState}
          onDelete={deleteLocation}
          onEdit={redirectToEdit}
          onTimingModal={redirectToModal}
          readOnly={isReadOnly}
        />
      </section>
    </main>
  );
};

module.exports = GymLocations;
